//@flow
import {
  ID_ESCALA_MOEDA_UNIDADES,
  ID_ESCALA_MOEDA_MILHARES,
  ID_ESCALA_MOEDA_MILHOES,
  ID_ESCALA_MOEDA_BILHOES,
  MULTIPLICADOR_ESCALA_MOEDA_MILHARES,
  MULTIPLICADOR_ESCALA_MOEDA_MILHOES,
  MULTIPLICADOR_ESCALA_MOEDA_BILHOES,
} from "../model/constantes";
import Big from "big.js";
import {
  __,
  any as anyRanda,
  includes,
  both,
  pathEq,
  propEq,
  over,
  curry,
  unless,
  isNil,
  view,
  o,
  fromPairs,
} from "ramda";
import { Maybe, type MaybeValue } from "ramda-fantasy";
import { takeLatest } from "redux-saga/effects";
import { FETCH_REMOTE_DATA } from "@quantum/remote-data";

import fuzzysearch from "fuzzysearch";
import { removeAccents } from "@quantum/utils";
import {
  strToU8,
  compressSync,
  strFromU8,
  decompressSync,
} from "fflate/esm/browser.js";
export * from "./resultado";

export function findEmLista(
  identificador: any,
  lista: Array<any>,
  atributo: string = "id"
): any {
  const obj = lista.find(item => item[atributo] === identificador);

  if (obj != null) {
    return obj;
  } else {
    throw new Error(`Objeto não encontrado com identificador ${identificador}`);
  }
}

export function truncate(num: number, places: number): any {
  return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
}

export const normalizarString = (str: string): string =>
  removeAccents(str).toLowerCase();

export const fuzzyMatch = (termo: string, texto: string): boolean => {
  const textoNormalizado = normalizarString(texto);
  const termoNormalizado = normalizarString(termo);

  return (
    textoNormalizado.startsWith(termoNormalizado) ||
    fuzzysearch(termoNormalizado, textoNormalizado)
  );
};

export const takeFetchRemoteData = (remote: string, ...props: any) =>
  takeLatest(
    both(propEq("type", FETCH_REMOTE_DATA), pathEq(["meta", "name"], remote)),
    ...props
  );

const MIN_ID = 1000000;
const MAX_ID = 9999999;

export const randomId = () =>
  Math.floor(Math.random() * (MAX_ID - MIN_ID) + MIN_ID);

export const getObjectKeyByValue = (obj: Object, searchValue: any): any => {
  for (let [key, value] of Object.entries(obj)) {
    if (value === searchValue) return key;
  }
};

export const parseQueryString = (queryString: string): { [string]: string } => {
  const params = queryString.startsWith("?")
    ? queryString.slice(1)
    : queryString;
  return fromPairs(params.split("&").map(param => param.split("=")));
};

export const debounce = (fn: Function, delay: number): Function => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

export const overIf = curry((lens, fn) =>
  unless(o(isNil, view(lens)), over(lens, fn))
);

export const anyIncludes = function(
  arrayIn: Array<any>,
  arraySearch: ?Array<any>
) {
  const fn = anyRanda(includes(__, arrayIn));
  return arguments.length === 1 ? fn : fn(arraySearch);
};

export const isMultiplasMedidasSelecionadas = (
  modoExibicaoSelecionado: any
): boolean => Array.isArray(modoExibicaoSelecionado);

export const maybeEmpty = <T>(value: ?T): MaybeValue<T> =>
  value ? Maybe(value) : Maybe.Nothing();

export const hash = (string: string): string => {
  for (var i = 0, h = 4928192840; i < string.length; i++) {
    h = Math.imul(h ^ string.charCodeAt(i), 2654435761);
  }
  return ((h ^ (h >>> 16)) >>> 0).toString(16);
};

export const tryParseJson: string => MaybeValue<any> = json => {
  try {
    return Maybe(JSON.parse(json));
  } catch (err) {
    return Maybe.Nothing();
  }
};

export const compressAndEncode = (data: *): string => {
  const dataStrigified = JSON.stringify(data);
  const dataU8 = strToU8(dataStrigified);
  const dataCompressed = compressSync(dataU8);
  const dataCompressedInBase64 = btoa(String.fromCharCode(...dataCompressed));

  return dataCompressedInBase64;
};

export const decompressAndDecode = (dataCompressedInBase64: string): * => {
  // $FlowFixMe
  const dataCompressed = Uint8Array.from(atob(dataCompressedInBase64), char =>
    // $FlowFixMe
    char.charCodeAt(0)
  );
  const dataU8 = decompressSync(dataCompressed);
  const dataStrigified = strFromU8(dataU8);
  const data = JSON.parse(dataStrigified);

  return data;
};

export const lazyFind = <T>(
  fn: T => boolean,
  gen: Generator<T, void, void>
): ?T => {
  let resultado = gen.next();
  let elementoEncontrado = null;
  // Usando while ao invés de for .. of por conta do IE11
  while (!resultado.done) {
    if (fn(resultado.value)) {
      elementoEncontrado = resultado.value;
      break;
    }
    resultado = gen.next();
  }
  return elementoEncontrado;
};

export const escalaFormatacao = (valor: any, escala: any) => {
  if (escala && !isNil(valor)) {
    switch (escala) {
      case ID_ESCALA_MOEDA_UNIDADES:
        return valor;
      case ID_ESCALA_MOEDA_MILHARES:
        return new Big(valor)
          .div(MULTIPLICADOR_ESCALA_MOEDA_MILHARES)
          .toNumber();

      case ID_ESCALA_MOEDA_MILHOES:
        return new Big(valor)
          .div(MULTIPLICADOR_ESCALA_MOEDA_MILHOES)
          .toNumber();

      case ID_ESCALA_MOEDA_BILHOES:
        return new Big(valor)
          .div(MULTIPLICADOR_ESCALA_MOEDA_BILHOES)
          .toNumber();

      default:
        return valor;
    }
  } else {
    return valor;
  }
};
